import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BackButtonComponent } from '@app/components/back-button/back-button.component';

@Component({
  selector: 'app-page-header',
  standalone: true,
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  host: {
    'role': 'button',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BackButtonComponent,
  ],
})
export class PageHeaderComponent {

  public readonly title = input<string | undefined>();

}
